module.exports = {
  IN: '+91',
  LK: '+94',
  BG: '+880'
}